import React from "react";
import { useLocation } from "react-router-dom"; 

import image1Sales from "../assets/icons/image1Sales.png";
import image2Sales from "../assets/icons/image2Sales.png";
import image3Sales from "../assets/icons/image3Sales.png";

import image1Marketing from "../assets/icons/image1Marketing.png";
import image2Marketing from "../assets/icons/image2Marketing.png";
import image3Marketing from "../assets/icons/image3Marketing.png";

import image1Finance from "../assets/icons/image1Finance.png";
import image2Finance from "../assets/icons/image2Finance.png";
import image3Finance from "../assets/icons/image3Finance.png";

import image1HR from "../assets/icons/image1HR.png";
import image2HR from "../assets/icons/image2HR.png";
import image3HR from "../assets/icons/image3HR.png";

import image1Procurement from "../assets/icons/image1Procurement.png";
import image2Procurement from "../assets/icons/image2Procurement.png";
import image3Procurement from "../assets/icons/image3Procurement.png";

import image1ProjectManagement from "../assets/icons/image1ProjectManagement.png";
import image2ProjectManagement from "../assets/icons/image2ProjectManagement.png";
import image3ProjectManagement from "../assets/icons/image3ProjectManagement.png";
import { AppointmentButtonWrapper, BVerticalContainer, BVerticalDescription, BVerticalImageWrapper, BVerticalRow, BVerticalSubTitle, BVerticalTextWrapper, BVerticalTitle } from "../assets/styles/BusinessVertical";
import { Button } from "@mui/material";



const sectionsData = {
  sales: [
    {
      title: "Pick your Reliable Partner",
      subtitle: "Streamline Partner Selection. Build Stronger Relationships",
      description:"Choosing the right partners doesn’t have to be a guessing game. With Devia, you can generate tailored risk assessments, ensuring every partner aligns with your goals. Our platform simplifies the evaluation process, offering clear insights into partner credibility and overall business standing. Say goodbye to uncertainty and hello to confident decision-making. Build lasting relationships and drive revenue with a solution designed for seamless partner selection.",
      image: image1Sales,
      reverse: false,
    },
    {
      title: "Financial Stability",
      subtitle: "Ensure Financial Stability",
      description:"<b>Financial stability is the foundation of strong partnerships.</b> Devia simplifies financial evaluations with powerful tools that analyze balance sheets, conduct in-depth ratio assessments, and provide actionable insights. Identify risks early, ensure your distributors and dealers are financially secure, and align your strategies for long-term growth. With Devia handling the complexities, you can have <b>peace of mind across your network.</b>",
      image: image2Sales,
      reverse: true,
    },
    {
      title: "Field Assessment",
      subtitle: "Real-Time Insights. Reliable On-Site Support",
      description:"Get a complete picture of your operations with Devia’s tailored field assessments. From warehouse management to inventory accuracy and protocol compliance, we catch potential issues before they become costly problems. Our customizable checklists, built with your expertise and our industry insights, ensure adherence to guidelines, safeguarding your investments and reducing risks. Keep your supply chain strong, efficient, and always one step ahead.",
      image: image3Sales,
      reverse: false,
    },
  ],
  marketing: [
    {
      title: "Evaluate Your Loyalty Programs",
      subtitle: "Maximize Engagement. Build Goodwill",
      description:"Are your loyalty programs truly rewarding your customers? With Devia’s impact assessment tools, you’ll gain a 360-degree view of program effectiveness. From on-ground verification to detailed parameter analysis, our platform helps you identify gaps and optimize initiatives. Strengthen customer engagement, drive loyalty, and enhance goodwill—all with insights you can trust.",
      image: image1Marketing,
      reverse: false,
    },
    {
      title: "Feedback Assessment",
      subtitle: "Turn Feedback Into Results",
      description:"Your customers are talking—are you listening? Devia makes it easy to capture, analyze, and act on feedback with tools like questionnaires, surveys, and on-site assessments. Gain valuable insights into your marketing strategies and refine campaigns to deliver better results. Stay ahead of the competition by adapting quickly and making every piece of feedback work for you. With Devia, your marketing efforts will soar.",
      image: image2Marketing,
      reverse: true,
    },
    {
      title: "Dashboard and Analytics",
      subtitle: "Insights That Drive Excellence",
      description:"Your data has stories to tell, and our dynamic dashboard is here to uncover them. With real-time visuals and intuitive analytics, you can track campaign performance, monitor key metrics, and make informed decisions. Stay ahead of trends, optimize your strategies, and achieve marketing excellence with ease. Devia’s dashboard transforms raw data into actionable insights, helping you lead the way in your industry.",
      image: image3Marketing,
      reverse: false,
    },
  ],
  hr: [
    {
      title: "Employee <br/> Background Checks",
      subtitle: "Hire with Confidence. Build with Trust",
      description:"<b>Devia’s employee background checks validate the information you rely on for hiring decisions.</b> From verifying credentials to uncovering hidden risks, our comprehensive checks ensure you have the full picture before bringing someone on board. With features like in-depth validation and on-ground verification, our platform delivers fast, reliable, and tailored insights. Make every hiring decision with peace of mind, knowing your workforce is built on a foundation of trust.",
      image: image1HR,
      reverse: false,
    },
    {
      title: "Discreet Checks",
      subtitle: "Insights Without Alarms",
      description:"<b>For senior management looking to assess performance and cultural fit, Devia’s discreet checks provide the perfect solution.</b> Designed to handle sensitive inquiries with care, our process uncovers critical information while preserving trust and privacy. Whether evaluating backgrounds or mitigating risks, our discreet approach ensures you gain valuable insights without compromising relationships.",
      image: image2HR,
      reverse: true,
    },
    {
      title: "Audited Reports and <br/>Real-Time Updates",
      subtitle: "Stay Informed. Stay Ahead",
      description:"<b>Devia keeps you in control with instant access to audited reports and real-time updates.</b> Gain a clear overview of every candidate’s history, track progress seamlessly, and address issues before they arise with up-to-the-minute insights. From detailed physical verifications to nuanced assessments, our platform ensures you’re always equipped to make informed decisions. With Devia, transparency and efficiency go hand in hand.",
      image: image3HR,
      reverse: false,
    },
  ],
  finance: [
    {
      title: "Integrated Platform",
      subtitle: "Seamless Collaboration Across Departments",
      description:"Imagine a platform where every department works in harmony, sharing documents and information effortlessly. Devia eliminates silos, enabling seamless collaboration and faster decision-making across your organization. With everything at your fingertips—anytime, anywhere—you’ll transform how your teams work together, driving agility and efficiency like never before.",
      image: image1Finance,
      reverse: false,
    },
    {
      title: "Step in, Upload, and Transform <br/> your document Management!",
      subtitle: "Smarter Document Management Starts Here",
      description:"Say goodbye to chaotic files and fragmented systems. With Devia’s intuitive onboarding app, you can easily upload and centralize your documents in a single, organized repository. From onboarding to day-to-day management, our platform simplifies the process, saving you time and effort. Document management has never been this smooth, efficient, or stress-free!",
      image: image2Finance,
      reverse: true,
    },
    {
      title: "Customer Risk Score",
      subtitle: "Customize. Analyze. Decide with Confidence",
      description:"Unlock the power of tailored risk assessments with our Customer Risk Score feature. Whether you choose our ready-to-use models or prefer to design a custom solution, Devia adapts to your needs. Dive deep into risk profiles, align strategies with your business goals, and make smarter, data-driven decisions—faster. With Devia, you’re always equipped to manage risk effectively.",
      image: image3Finance,
      reverse: false,
    },
  ],
  procurement: [
    {
      title: "Supplier Selection",
      subtitle: "Find the Perfect Fit. Minimize Risks",
      description:"<b>Choosing the right suppliers is the foundation of an efficient supply chain.</b> Devia simplifies the selection process with deep visibility into financial metrics and key indicators. Our platform ensures every supplier aligns with your needs, providing complete transparency and control. Reduce risks, prevent losses, and secure partnerships that drive your business forward with confidence.",
      image: image1Procurement,
      reverse: false,
    },
    {
      title: "Conquer Off Contract Spends",
      subtitle: "Control Budgets. Maximize Savings",
      description:"<b>Uncontrolled off-contract spending can derail even the best-laid budgets.</b> Devia helps you regain control with detailed tracking, vendor repositories, and comprehensive insights into supplier expenditures. Emergency supplier hiring only adds to the challenge, increasing costs and disrupting financial planning. Our platform empowers you to eliminate compliance risks, reduce unexpected expenses, and capture missed savings. Align your spending with business goals, optimize budgets, and drive sustainable financial growth—all from one centralized solution.",
      image: image2Procurement,
      reverse: true,
    },
    {
      title: "Measurement of Supplier <br/> Performance",
      subtitle: "Track. Improve. Excel.",
      description:"<b>Inconsistent supplier performance can cost time and money.</b> Devia empowers you to track and enhance supplier performance with <b>customizable scorecards and performance metrics,</b> ensuring alignment with your business goals. Gain full visibility into supplier efficiency, identify gaps, and collaborate proactively to drive improvements. Our platform enables data-driven decision-making, helping you optimize operations and build strong, high-performing supplier partnerships that deliver consistent results.",
      image: image3Procurement,
      reverse: false,
    },
  ],
  projectManagement: [
    {
      title: "Instant KYC Insights",
      subtitle: "Fast, Reliable, Seamless",
      description:"Onboarding just got smarter. With Devia’s Instant KYC Insights, you can access critical information in seconds through our integration with 80+ trusted APIs. Verify employees, partners, and customers effortlessly-right out of the box. Ensure every decision is backed by reliable data, streamline onboarding, and build trust across your network. With Devia, it’s not just verification; it’s confidence at every step.",
      image: image1ProjectManagement,
      reverse: false,
    },
    {
      title: "Custom Filters & Triggers",
      subtitle: "Insights That Work for You",
      description:"One size doesn’t fit all-your business is unique, and your insights should be too. With Devia’s Custom Filters & Triggers, you can design data combinations and risk parameters that matter most to your operations. Track project-specific metrics, locations, and risk types with precision. Define what’s important and let our platform do the rest, giving you smarter insights for better decisions.",
      image: image2ProjectManagement,
      reverse: true,
    },
    {
      title: "Proactive Monitoring and Alerts",
      subtitle: "Stay Ahead, Always",
      description:"Don’t just react—anticipate. Devia’s Proactive Monitoring continuously analyzes financials, ratios, and other key metrics to deliver real-time alerts before issues arise. Whether it’s a potential compliance risk or operational hiccup, you’ll have the context you need to act fast. Minimize disruptions, mitigate risks, and keep your projects running smoothly with insights you can count on.",
      image: image3ProjectManagement,
      reverse: false,
    },
  ],
};

const BVertical = () => {
  const location = useLocation();

  const isSales = location.pathname.includes("sales");
  const isMarketing = location.pathname.includes("marketing");
  const isFinance = location.pathname.includes("finance");
  const isHR = location.pathname.includes("hr");
  const isProcurement = location.pathname.includes("procurement");
  const isProjectManagement = location.pathname.includes("project-management");

  const currentSection = 
    isSales ? sectionsData.sales : 
    isMarketing ? sectionsData.marketing :
    isFinance ? sectionsData.finance :
    isHR ? sectionsData.hr : 
    isProcurement ? sectionsData.procurement :
    isProjectManagement ? sectionsData.projectManagement :
    [];  

  if (!Array.isArray(currentSection)) {
    console.error("Invalid section data: ", currentSection);
    return null; 
  }

  return (
    <>
    <BVerticalContainer>
      {currentSection.length > 0 ? (
        currentSection.map((section, index) => (
          <BVerticalRow
            key={index}
            style={{ flexDirection: section.reverse ? "row-reverse" : "row" }}
          >
            <BVerticalTextWrapper reverse={section.reverse}>
            
              <BVerticalTitle dangerouslySetInnerHTML={{ __html: section.title }} />
              <BVerticalSubTitle>{section.subtitle}</BVerticalSubTitle>
              <BVerticalDescription dangerouslySetInnerHTML={{ __html: section.description }} />
            </BVerticalTextWrapper>
            <BVerticalImageWrapper src={section.image} alt={section.title} loading="lazy"/>
          </BVerticalRow>
        ))
      ) : (
        <p>No content available for this section.</p>
      )}
    </BVerticalContainer>
    <AppointmentButtonWrapper>
        <Button className="custom-button" variant="contained">Book an Appointment</Button>
    </AppointmentButtonWrapper>
    </>
  );
};

export default BVertical;
